import React from 'react'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ParentServiceOrderLoader from './_load/ParentServiceOrderLoader'

const TemplateBosiPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={parseInt(id)}>
        <ParentServiceOrderLoader>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent templateId={parseInt(templateId)} />
        </ParentServiceOrderLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateBosiPdfPage
